import { TemplateResult, html } from "lit";
import { BaseElement } from "../BaseElement";
import { makeCustomEvent } from "../../Utils";
import { wrapWithTooltipAndHelp } from "./WrapWithTooltipAndHelp";
import { litIf } from "../LitUtils";

export function renderSelect(
    root: BaseElement,
    choices: string[],
    object: any,
    prop: string,
    label?: string,
    helpMsg?: string,
    multiple = false,
    maxOptionsVisible = 0,
    onModified?: () => void,
    convertToEnum?: (v: any) => any,
    convertFromEnum?: (v: any) => any,
    displayText?: (v: any) => string
): TemplateResult {
    if (!object) {
        return html``;
    }

    function toKey(v: string | string[] | undefined): string | string[] {
        if (!v) {
            return "all";
        }

        if (Array.isArray(v)) {
            return v.map((x: string) => toKey(x)) as string[];
        }

        return v.replace(/\s/g, "-").toLowerCase();
    }
    const keyToValue = new Map<string, string>(choices.map((x: string) => [toKey(x) as string, x]));

    if (!convertToEnum) {
        convertToEnum = (x) => x;
    }
    if (!convertFromEnum) {
        convertFromEnum = (x) => x;
    }
    if (!displayText) {
        displayText = (x) => x;
    }

    let val = toKey(convertToEnum(object[prop]));

    if (Array.isArray(val)) {
        val = (val as any[]).join(" ");
    }

    let elem = html`<sl-select
        hoist
        pill
        filled
        size="medium"
        class="editor-grid-item"
        value=${val}
        ?multiple=${multiple}
        max-options-visible=${maxOptionsVisible}
        @sl-change=${(e: any) => {
            if (multiple) {
                let updateProp = true;
                if (e.target.value.includes("all")) {
                    if (object[prop] !== undefined) {
                        object[prop] = undefined;
                        updateProp = false;
                        e.target.value = ["all"];
                    }
                } else if (e.target.value.length === 0) {
                    e.target.value = ["all"];
                    object[prop] = undefined;
                    updateProp = false;
                }
                if (updateProp) {
                    object[prop] = convertFromEnum(
                        e.target.value
                            .filter((x: string) => x !== "all")
                            .map((x: string) => keyToValue.get(x))
                    );
                    e.target.value = object[prop].map((x: string) => toKey(x));
                }
            } else {
                object[prop] =
                    e.target.value === "all"
                        ? undefined
                        : convertFromEnum(keyToValue.get(e.target.value));
            }
            if (onModified) {
                onModified();
            }
            root.dispatchEvent(
                makeCustomEvent("ds-item-changed", {
                    property: prop,
                })
            );
        }}
    >
        ${litIf(multiple, () => html`<sl-option value="all">All</sl-option>`)}
        ${choices.map(
            (x) => html`<sl-option value="${toKey(x) as string}">${displayText(x)}</sl-option>`
        )}
    </sl-select>`;

    if (helpMsg) {
        elem = wrapWithTooltipAndHelp(root, elem, helpMsg);
    }

    return html`${label
        ? html`<span class="editor-label editor-grid-item">${label}</span>`
        : html`<span></span>`}${elem}`;
}
